import React from 'react';
import { TrackingModuleLayout } from '../layouts/TrackingModuleLayout';
import { HomeContent } from '../components/HomeContent/HomeContent';

export default function Home() {
    return (
        <TrackingModuleLayout hideSearchBar={true}>
            <HomeContent />
        </TrackingModuleLayout>
    );
}
